module.exports = __webpack_public_path__ + "static/media/step-backward-circle.82c2b033.svg";